import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  insertImage(event) {
    const imageId = parseInt(event.currentTarget.dataset.id);
    window.kraut.MarkdownEditor.appendText(`[image:${imageId}]\n`);
  }
}
